import { Component, OnInit } from '@angular/core';
import { ThemeConstantService } from 'app/shared/services/theme-constant.service';
import { ApiService } from 'app/providers/api.service';
import { TransferService } from 'app/shared/services/transfer.service';

import {MatSnackBar} from '@angular/material/snack-bar';
import { FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list'

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tckts-asgnd',
  templateUrl: './tckts-asgnd.component.html',
  styleUrls: ['./tckts-asgnd.component.scss']
})
export class TcktsAsgndComponent implements OnInit {

  shwLdg: boolean;
  isFolded: any;
  isSideNavDark: any;
  selectedHeaderColor: any;
  isExpand: any;
  columnDefs;
  tcktsLst;
  acceptData;
  fnlImgs;

  constructor( public apiSrv: ApiService, private themeService: ThemeConstantService,
    private _snackBar: MatSnackBar,public TransferService: TransferService,
    private router: Router) { }

  ngOnInit() {
    // alert("8888888888")
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
    this.themeService.selectedHeaderColor.subscribe(color => this.selectedHeaderColor = color);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.gettcktsLst();
  }

  gettcktsLst(){
    this.shwLdg = true;
    const rte = 'ticket/gettcktslst';
    this.apiSrv.get(rte).subscribe(res => {
      this.tcktsLst = res['data'];
      console.log(this.tcktsLst)
      this.shwLdg = false;
    });
  }

  // onEdit2(data){
  //   this.TransferService.setLoclData('prfleData',data.row.data);
  //   this.route.navigate([`internal/help/support/edit-ticket`])
  // }

  crtetckt(){
    this.router.navigate([`/support/create-ticket`])
  }

viewDtls(n){
console.log(n);
this.TransferService.setLoclData('prfleData', n);
this.router.navigate([`cpay/cstmr`]);
}

// createMessage(type: string, msg: string): void {
//   this.message.create(type, msg);
// }
// openSnackBar(message: string, action: string) {
//   this._snackBar.open(message, action);
// }

}
